<template>
  <div :class="['photo-info', { 'has-btn': hasBtn }, {'has-img-fixed': hasImgFixed}, {'has-img-float': hasImgFloat}, {'has-new-btn': isNewFunnel && !isFleetPCFunnel}, `${page_style}`]">
    <div v-for="(item, idx) in form" :key="idx" :class="['photo-item', item.type]">
      <component
        :is="getCom(item)"
        :form-item="item"
        :idx="idx"
        @form-update="formUpdate"
        :cm="true"
        :is_finished="is_finished"
        :is_ocr="is_ocr"
        :page_type="page_type"
        :page_style="page_style"
        :can-upload="canUpload"
        :omega-item="omegaItem"
        :product="auditInfo.product"
        :onboarding_driver_id="auditInfo.onboarding_driver_id"
        @reloadConfig="getPageConfig"
      ></component>
    </div>
    <fleet-stay-pop ref="fleetStayPop" :alertInfo="alertInfo"></fleet-stay-pop>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { post } from "../tools/request";
import { showAlertDialog, showLoadingToast, showToast } from "../tools/Tip";
import { setTitle } from "../tools/setTitle";
import { ends } from "../tools/constant";
import { getEnd } from "../tools/utils";
import {
  formatCPFBr,
  formatCNPJBr,
  formatCarPlateBr,
  formatAccent,
  formatCURPMx,
  formatRUT,
  formatCURPCr,
  computeJumpTime,
  computeStayTime
} from "../tools/utils";

import Banner from "./base/Banner";
import Tip from "./base/Tip";
import SubTitle from "./base/SubTitle";
import Input from "./base/Input";
import ChooseInput from "./base/choose-input";
import DefaultSelect from "./base/default-select";
import UploadSelect from "./base/upload-select";
import ThirdLink from "./base/third-link";
import BankCardBr from "./base/bank-card-br";
import ImgLink from "./base/img-link";
import TextLink from "./base/text-link";
import DatePicker from "./base/date-picker";
import PhotoInfoBtn from "./base/photo-info-btn";
import CheckBox from "./base/check-box";
import TipColored from "./base/tip-colored";
import ImgLinkFixed from "./base/img-link-fixed.vue";
import ImgLinkFloat from "./base/img-link-float.vue";
import DownloadBtn from "./base/download-btn";
import RoleTransitionBtn from "./base/role-transition-btn";
import HomeBanner from "./loginComp/home-banner.vue";
import ProgressBar from "./baseAudit/progress-bar.vue";
import OptionAudit from "./baseAudit/optionAudit.vue";
import Tips from "./baseAudit/tips.vue";
import SubmitBtn from "./baseAudit/submit-btn.vue";
import FleetStayPop from "./base/fleet-stay-pop.vue"


export default {
  name: "photoInfo",
  components: {
    Banner,
    Tip,
    SubTitle,
    Input,
    ChooseInput,
    DefaultSelect,
    UploadSelect,
    ThirdLink,
    BankCardBr,
    ImgLink,
    DatePicker,
    PhotoInfoBtn,
    TextLink,
    CheckBox,
    TipColored,
    DownloadBtn,
    RoleTransitionBtn,
    HomeBanner,
    ProgressBar,
    OptionAudit,
    SubmitBtn,
    Tips,
    FleetStayPop
  },
  data() {
    return {
      timeId: null,
      is_finished: false, //证件页
      is_ocr: false, //全局的是否参与ocr实验的标志
      form: [],
      page_type: "", //证件列表页顶部控制
      is_img_fixed: false, // 跳转按钮下方有固定img
      page_style: "", // 新老funnel样式控制
      canUpload: true, // 新funnel证件上传前需要判断是否已经填写完基础信息
      is_cycle: null, // 新证件页是否需要轮询
      alertInfo: {}, // 挽留弹窗信息
      auditInfo: {},
    };
  },
  watch: {
    is_finished(newVal) {
      if (newVal) {
        Fusion.resetBack &&
          Fusion.resetBack({
            reset: 2
          });
        // fleet安卓的老的重置返回
        Fusion.cancelBackPressedControl && Fusion.cancelBackPressedControl({}, () => {} )
        Fusion.interceptGoback &&
          Fusion.interceptGoback({ needs_intercept: false }, () => {});
      }
    }
  },
  computed: {
    ...mapState([
      "_ticket",
      "_uuid",
      "_page_stay_time",
      "_page_jump_time",
      "_route_path"
      ]),
    hasBtn() {
      return this.form.find(x => x ? x.type === "button" : false);
    },
    params() {
      return new URLSearchParams(location.search);
    },
    isPreviewPage() {
      return this.params.get('ob_page_type') === 'preview';
    },
    hasImgFixed() {
      return this.form.some(i => i.type === 'img-link-fixed') || false;
    },
    hasImgFloat() {
      return this.form.some(i => i.type === 'img-link-float') || false;
    },
    isNewFunnel() {
      return ["h5_funnel", "h5_funnel_fleet", "h5_funnel_fleet_pc"].includes(this.page_style);
    },
    isFleetFunnel() {
      return ["h5_funnel_fleet", "h5_funnel_fleet_pc"].includes(this.page_style);
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    omegaItem() {
      return {
        channel: this.params.get("channel") || "",
        end: getEnd(),
        oid: this.params.get("oid") || Omega.getOmgid(),
        location_country_code: this.params.get("location_country"),
        driver_id: this.params.get("uid") || this._uuid + '',
        page: this.isNewFunnel ? 1 : 0
      };
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    formatCPFBr,
    formatCNPJBr,
    formatCarPlateBr,
    formatAccent,
    formatCURPMx,
    formatRUT,
    formatCURPCr,
    getPageConfig(type) {
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (this.isPreviewPage) {
        up.set("page", 'jobs_page_conf');
      }
      let PHOTOINFO_URL = this.isPreviewPage ? process.env.PHOTOINFO_URL_PRE : process.env.PHOTOINFO_URL
      post(PHOTOINFO_URL, up)
        .then(data => {
          this.auditInfo = data;
          this.page_style = data.page_style || '';
          this.formatData(data.form);
          this.is_finished = data.is_finished || false;
          this.is_ocr = data.is_ocr || false;
          this.page_type = data.page_type || "";
          this.canUpload = this.isNewFunnel ? [3,4].includes(data.basic_info_field_status) : true;
          this.is_cycle =  data.is_cycle;
          data.title && setTitle(data.title);
          // 如果是fleet流程，调起挽留弹窗
          if (this.page_style === 'h5_funnel_fleet') {
            this.setFleetStayPop();
          }
          // 新老实验曝光埋点
          try {
            if (this.isNewFunnel) {
              Omega.trackEvent("ibt_gd_upload_people_num_sw", "", {
                ...this.omegaItem,
                // time: new Date().getTime()
              });
            }
          } catch (error) { }

          if (!this.isPreviewPage && (this.isNewFunnel && this.is_cycle || !this.isNewFunnel) && type !== 'reload') {
            this.timeId = setTimeout(this.loop, 5 * 1000);
          }
        })
        .catch(err => {
          const { errmsg } = err;
          showAlertDialog(this, errmsg);
          try {
            Omega.trackEvent("ibt_register_certificate_list_error_ck", '' , {
              path_url: PHOTOINFO_URL,  //接口url
              message: JSON.stringify(err),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: err.errno,  //报错码
            });
          } catch (e) {}
        })
        .finally(() => {
          this.toast.hide();
          if (this.is_finished && this.is_ocr && window.localStorage) {
            try {
              if (!window.localStorage.getItem("show_toast")) {
                showToast(this, {
                  type: "correct",
                  txt: this.$t("get_all_doc"),
                  time: 3500
                });
                window.localStorage.setItem("show_toast", "done");
              }
            } catch (e) {
              console.log(e);
            }
          }
          if(this.is_finished){
            try{
                gtm({ 'event': 's7ObUpload',
                'DocComplete': 'true',
                  'error': 'false' })
              }catch(e){}
          }
        });
    },
    loop() {
      // this.loopPageConfig();
      // if (!this.isPreviewPage && (this.isNewFunnel && this.is_cycle || !this.isNewFunnel)) {
        this.loopProcess();
      // }
    },
    loopProcess() {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      post(process.env.GET_PROGRESS_URL, up)
        .then(data => {
          if (data.progress === "result" || data.progress === "resultInfo") {
            this.leave();
            this.$router.replace({ name: "home" });
          } else {
            this.loopPageConfig();
          }
        })
        .catch(err => console.log(err));
    },
    loopPageConfig() {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      post(process.env.PHOTOINFO_URL, up)
        .then(data => {
          this.auditInfo = data;
          this.is_finished = data.is_finished || false;
          this.is_ocr = data.is_ocr || false;
          this.page_type = data.page_type || "";
          this.page_style = data.page_style || '';
          this.is_cycle =  data.is_cycle;
          let oldData = this.form,
            resData = data.form;
          //遍历form对比变化项，若变化则不使用新值
          //注意需要format,只有输入项才需要进行比对
          resData.forEach((item, idx) => {
            // //4-->>success，取返回值即可
            // if (item.field_status == 4) {
            //   return;
            // }
            let formItem = oldData[idx];
            if (item.type === "input") {
              let v = item.value,
                format = item.format;
              if (format) {
                v = this[format](v);
              }
              //展示项取用户输入的值；
              item.value = formItem.value;
              if (item.field_status == 4) {
                //success 时 取返回后格式化的值
                item.value = v;
                item.valid = true;
              } else if (v != oldData[idx].value) {
                //下方状态提示，可能有checking变成其他，所以当值一致时取返回值
                item.field_status = formItem.field_status;
                item.field_result = formItem.field_result;
                item.valid = formItem.valid;
              }
            } else if (item.type === "chooseInput") {
              let options = item.options;
              options.forEach((item, idx2) => {
                let v = item.value,
                  format = item.format;
                if (format) {
                  v = this[format](v);
                }
                //展示项取用户输入的值；
                item.value = formItem.options[idx2].value;
                if (item.field_status == 4) {
                  //success 时 取返回后格式化的值
                  item.value = v;
                  item.valid = true;
                } else if (v != formItem.options[idx2].value) {
                  //下方状态提示，可能有checking变成其他，所以当值一致时取返回值
                  item.field_status = formItem.options[idx2].field_status;
                  item.field_result = formItem.options[idx2].field_result;
                  item.valid = formItem.options[idx2].valid;
                }
              });
            }
          });
          this.formatData(resData);
          this.timeId = setTimeout(this.loop, 5 * 1000);
        })
        .catch(err => {
          try {
            Omega.trackEvent("ibt_register_certificate_list_error_ck", '' , {
              path_url: process.env.PHOTOINFO_URL,  //接口url
              message: JSON.stringify(err),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: err.errno,  //报错码
            });
          } catch (e) {}
        });
    },
    //接收各组件发送的更新emit
    formUpdate(idx) {
      this.$set(this.form, idx, this.form[idx]);
      this.$emit("btn-update");
    },
    formatData(data) {
      if (!this.isNewFunnel) {
        this.form = data || [];
        return;
      }
      let formData = [];
      let other_option = [];
      const has_option_banner = data.some(item => item.type === 'other_banner')
      if (has_option_banner) {
        data.forEach((item, idx) => {
          if (item.required === false) {
            other_option.push(item)
          } else {
            formData.push(item)
          }
        })
        formData.forEach((item) => {
          if (item.type === 'other_banner') {
            item.options = other_option;
          }
        })
        console.log(formData)
        this.form = formData || [];
      } else {
        this.form = data || [];
      }
    },
    getCom(item) {
      return {
        banner: Banner,
        input: Input,
        chooseInput: ChooseInput,
        select: DefaultSelect,
        tips: Tip,
        subTitle: SubTitle,
        photo: UploadSelect,
        portrait: UploadSelect,
        declare: UploadSelect,
        color: UploadSelect,
        "linkage-photo": UploadSelect,
        "link-photo": UploadSelect,
        "multi-photo": UploadSelect,
        "multi-declare": UploadSelect,
        date: DatePicker,
        "third-link": ThirdLink,
        "bank-card-br": BankCardBr,
        "img-link": ImgLink,
        "text-link": TextLink,
        button: PhotoInfoBtn,
        "submit_button": SubmitBtn,
        checkBox: CheckBox,
        "tip-color": TipColored,
        "introduce": UploadSelect,
        "select-photo": UploadSelect,
        "inner-input": UploadSelect,
        "in_select_photo": UploadSelect,
        "photo_new": UploadSelect,
        "photo_simplify": UploadSelect,
        "avatar_new": UploadSelect,
        "img-link-fixed": ImgLinkFixed,
        "img-link-float": ImgLinkFloat,
        "download-button": DownloadBtn,
        "jump-button": RoleTransitionBtn,
        "basic_info": UploadSelect, // 基础信息作为证件的一项
        "rotation-banner": HomeBanner,
        "progress_bar": ProgressBar,
        "other_banner": OptionAudit,
        "tip": Tips,
        "tip_new": Tips,
      }[item.type];
    },
    interceptGoback() {
      //20200228 vamos设置返回拦截
      let up = new URLSearchParams(location.search);
      if (ends.isPassengerTerminal && up.get("business_line") === "oasis") {
        Fusion.interceptGoback &&
          Fusion.interceptGoback(
            {
              needs_intercept: true,
              intercept_style: 1,
              intercept_model: {
                title: this.$t(
                  "Global_Rider_Oasis_on_boarding0104_GlobalRider_Certification_owner_ixFB"
                ),
                subtitle: this.$t(
                  "Global_Rider_Oasis_on_boarding0104_GlobalRider_Fill_in_ISdI"
                ),
                confirm_btn_title: this.$t(
                  "Global_Rider_Oasis_on_boarding0104_GlobalRider_Exit_TVIb"
                ),
                cancel_btn_title: this.$t(
                  "Global_Rider_Oasis_on_boarding0104_GlobalRider_Certification_continue_KzyL"
                )
              },
              omega_config: {
                sw_event: "gd_vamosExitregister_view_sw",
                confirm_ck_event: "gd_vamosExitregister_continue_ck",
                cancel_ck_event: "gd_vamosExitregister_back_ck",
                params: { type: "Certificate" }
              }
            },
            () => {}
          );
      }
    },
    leave() {
      clearTimeout(this.timeId);
      Fusion.resetBack &&
        Fusion.resetBack({
          reset: 2
        });
      // fleet安卓的老的重置返回
      Fusion.cancelBackPressedControl && Fusion.cancelBackPressedControl({}, () => {} )
      //20200228 vamos设置返回拦截
      Fusion.interceptGoback &&
        Fusion.interceptGoback({ needs_intercept: false }, () => {});
    },
    setFleetStayPop() {
      // 设置fleet的挽留弹窗
      const back_pop_show = window.localStorage && window.localStorage.getItem("back_pop_show");
      const location_country = this.params.get("location_country")
      // 返回挽留弹窗
      if (!back_pop_show) {
          Fusion && Fusion.resetBack && Fusion.resetBack({
              reset: 0,
              jsCallback: '_PAGE_GO_BACK'
          });
      } else {
        Fusion && Fusion.resetBack &&
          Fusion.resetBack({
            reset: 2
          });
      }
      let that = this;
      // 返回上一级
      window._PAGE_GO_BACK = () => {
        if (!back_pop_show) {
            that.alertInfo = {
              title: that.$t('Fleet_optimizaton__fbmb'),
              desc: that.$t('Fleet_optimizaton__pOXK').replace(/\{\{brand_name\}\}/, location_country === 'BR' ? that.$t('GDriver_Name_99_mpNh') : that.$t('GDriver_Name_DiDi_Gsik')),
              btn: {
                yes: that.$t('Fleet_optimizaton__zsVd'),
                no: that.$t('Fleet_optimizaton__qKWw'),
              }
            }
            that.$refs.fleetStayPop.popShow = true;
            window.localStorage && window.localStorage.setItem("back_pop_show", "true");
        } else {
            Fusion.closePage({}, () => {});
        }
      };
    }
  },
  beforeDestroy () {
    try {
      computeStayTime(this)
    } catch (error) {}
    this.leave();
  },
  beforeCreate () {
    //进入证件页，返回时给确认提示
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 1,
        url: window.location.href,
        content: this.$t("未全部提交确认返回？"),
        okButtonContent: this.$t("确认"),
        cancelButtonContent: this.$t("取消")
      });
  },
  mounted() {
    //解决非正常流程进入--页面刷新，多次请求的bug，旧的i8n作用域已不存在，js有抛错，中断执行，，所以不会触发fn，很hack的做法
    this.timeId=setTimeout(this.getPageConfig, 0);
    this.interceptGoback();
    try {
      computeJumpTime(this)
    } catch (error) {}
    try {
      Omega.trackEvent("gd_driverMesList_view_sw", "", {
        ...this.omegaItem,
        // time: new Date().getTime()
      });
      gtm({ 'event': 's7ObUpload',
        'DocComplete': 'false',
          'error': 'false' })
      snaptr('track', 'LIST_VIEW', {eventID: Omega.getOmgid()});
      fbq('track', 'Lead', {eventID: Omega.getOmgid()});
    } catch (e) {}
  }
};
</script>
<style lang="scss" scoped>
.photo-info.h5_funnel,
.photo-info.h5_funnel_fleet,
.photo-info.h5_funnel_fleet_pc {
  position: relative;
  // overflow: scroll;
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 2.2rem;
  background: #fff;
  .home-banner.h5_funnel {
    margin-bottom: 0.54rem;
  }
  .photo-item.progress_bar{
    position: sticky;
    top: 0;
    z-index: 1;
  }
  &.h5_funnel_fleet_pc {
    min-height: auto;
    padding: 0 48px;
    .rotation-banner {
      width: calc(100% + 96px);
      margin-left: -48px;
    }
  }
}
</style>